import * as React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  muiSVG: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fontSize: '1.5rem',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexShrink: '0',
    userSelect: 'none',
  }
}));

export const TeddyBear = () => {
  const classes = useStyles()

  return (
    // <xml version="1.0" encoding="iso-8859-1">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 357.153 357.153" xmlSpace="preserve" className={classes.muiSVG}>
<g>
	<g id="Layer_5_41_">
		<g>
			<circle cx="177.567" cy="120.841" r="12.338"/>
			<path d="M272.81,282.602c-5.939-3.188-5.025-8.935-5.025-12.538v-50.341c17.373-3.548,55.607-3.874,55.607-38.214
				c0-16.969-13.844-23.183-30.727-21.466c-13.463,1.368-19.795,10.353-42.602,1.775c-2.891-1.087-10.957-8.202-6.339-13.831
				c11.806-14.393,18.466-33.157,18.466-53.363c0-3.303-0.028-9.921,2.934-11.157c15.189-6.34,25.461-22.073,25.461-39.859
				C290.585,19.525,271.408,0,247.755,0c-12.823,0-24.328,5.742-32.178,14.835c-0.687,0.797-1.915,2.451-4.924,1.152
				c-10.654-5.012-19.57-6.498-32.078-6.498c-13.434,0-23.197,1.812-34.446,7.544c-3.55,1.086-5.962-2.571-7.717-4.346
				C128.671,4.848,118.009,0,106.229,0C82.575,0,63.397,19.524,63.397,43.608c0,18.489,11.303,34.289,27.257,40.632
				c1.542,0.613,3.925,2.463,4.306,10.384c0.963,20.033,6.816,38.489,18.213,53.038c4.227,5.394,0.154,12.357-6.207,14.323
				c-23.203,7.173-29.063-0.559-42.477-1.943c-16.881-1.742-30.727,4.497-30.727,21.466c0,33.416,38.223,34.606,55.604,38.104
				v50.451c0,3.702,0.518,8.887-7.201,13.656c-21.557,8.884-52.498,9.57-52.498,39.738c0,18.357,15.225,36.778,33.238,33.238
				c22.566-4.433,34.411-11.924,68.651-27.42c7.374-3.36,12.577-1.675,15.815-1.221c9.713,1.364,20.228,1.892,31.203,1.892
				c12.263,0,23.949-0.658,34.582-2.406c2.684-0.441,8.96-0.694,14.722,1.648c33.415,15.554,44.138,23.032,66.37,27.507
				c17.996,3.622,33.238-14.881,33.238-33.238C327.488,293.291,294.328,291.6,272.81,282.602z M219.045,133.18
				c0,17.972-18.569,32.544-41.479,32.544c-22.906,0-41.478-14.572-41.478-32.544c0-17.974,18.571-32.544,41.478-32.544
				C200.475,100.636,219.045,115.206,219.045,133.18z M117.879,79.506c0-8.178,6.627-14.807,14.806-14.807
				c8.177,0,14.808,6.629,14.808,14.807s-6.631,14.807-14.808,14.807C124.506,94.312,117.879,87.683,117.879,79.506z
				 M228.684,262.682c0,27.673-22.435,40.1-50.106,40.1c-27.674,0-50.107-12.427-50.107-40.1V239.12
				c0-27.673,22.434-50.106,50.107-50.106c27.672,0,50.106,22.434,50.106,50.106V262.682z M217.207,94.312
				c-8.178,0-14.807-6.629-14.807-14.807s6.629-14.807,14.807-14.807s14.807,6.629,14.807,14.807S225.385,94.312,217.207,94.312z"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
  )
}

